import { toPairs } from "ramda";

import { buildIframeURL, removeHeightFromStyle } from ".";

import { TAB_STRING } from "../constants";

const camelCasedAppName = globalProps.appName.replace(/^neeto/i, "neeto");

const embedBaseScript = embedScriptLink =>
  `<script>window.${camelCasedAppName} = window.${camelCasedAppName} || { embed: function(){(${camelCasedAppName}.q=${camelCasedAppName}.q||[]).push(arguments)} };</script>
  <script async
    src="${embedScriptLink}">
  </script>`;

const embedEnv = () =>
  globalProps.railsEnv !== "production"
    ? `\n${TAB_STRING}  env: "${globalProps.railsEnv}",`
    : "";

const embedQueryParam = queryParams =>
  queryParams ? `\n${TAB_STRING}  queryParams: ${queryParams},` : "";

const parseExtraArgs = extraArgs =>
  toPairs(extraArgs).map(
    ([key, value]) => `\n${TAB_STRING}  ${key}: "${value}"`
  );

const inlineEmbedCode = ({
  customization,
  id,
  embedScriptLink,
  extraArgs,
  inlineWrapperStyle,
  iframeStyle,
  queryParams,
}) => {
  const { elementSelector, dynamicHeight } = customization;

  const processedInlineWrapperStyle = dynamicHeight?.value
    ? removeHeightFromStyle(inlineWrapperStyle)
    : inlineWrapperStyle;

  return `
  <!-- ${globalProps.appName} inline embed code begins -->
  <div style="${processedInlineWrapperStyle}" id="${elementSelector}">
    <!-- ${globalProps.appName} widget will be added here -->
  </div>
  ${embedBaseScript(embedScriptLink)}
  <script>
    ${camelCasedAppName}.embed({
      type: "inline",
      id: "${id}",
      organization: "${globalProps.organization.subdomain}",
      elementSelector: "#${elementSelector}",
      styles: "${iframeStyle}", ${embedQueryParam(
    queryParams
  )}${embedEnv()}${parseExtraArgs(extraArgs)}
    });
  </script>
  <!-- ${globalProps.appName} inline embed code ends -->`;
};

const floatingPopupEmbedCode = ({
  customization,
  id,
  embedScriptLink,
  extraArgs,
  queryParams,
}) => {
  const { btnTextColor, showIcon, btnText, btnPosition, btnColor, icon } =
    customization;

  return `
  <!-- ${globalProps.appName} floating-popup embed code begins -->
  ${embedBaseScript(embedScriptLink)}
  <script>
    ${camelCasedAppName}.embed({
      type: "floatingPopup",
      id: "${id}",
      organization: "${globalProps.organization.subdomain}",
      styles: {
        btnTextColor: "${btnTextColor}",
        btnPosition: "${btnPosition}",
        btnColor: "${btnColor}",
        btnText: "${btnText}", ${
    icon ? `\n${TAB_STRING}${TAB_STRING}showIcon: ${showIcon},` : ""
  }
      },${embedQueryParam(queryParams)}${embedEnv()}${parseExtraArgs(extraArgs)}
    });
  </script>
  <!-- ${globalProps.appName} floating-popup embed code ends -->`;
};

const elementPopupEmbedCode = ({
  customization,
  id,
  embedScriptLink,
  extraArgs,
  queryParams,
}) => {
  const { elementSelector } = customization;

  return `
  <!-- This is a demo button, you can use any element on your website instead. -->
  <!-- <button id="${elementSelector}">Click to open popup</button> -->

  <!-- ${globalProps.appName} element-click embed code begins -->
  ${embedBaseScript(embedScriptLink)}
  <script>
    ${camelCasedAppName}.embed({
      type: "elementClick",
      id: "${id}",
      organization: "${globalProps.organization.subdomain}",
      elementSelector: "#${elementSelector}",${embedQueryParam(
    queryParams
  )}${embedEnv()}${parseExtraArgs(extraArgs)}
    });
  </script>
  <!-- ${globalProps.appName} element-click embed code ends -->`;
};

const iframeEmbedCode = ({
  id,
  customization,
  queryParams,
  embedScriptLink,
}) => {
  const { height, width, iframeTitle, iframeUrl, dynamicHeight } =
    customization;

  const iframeSrc = buildIframeURL({ id, iframeUrl, queryParams });

  const heightAttribute = dynamicHeight?.value
    ? ""
    : `\n${TAB_STRING}height="${height}"`;

  return `
  <!-- ${globalProps.appName} iframe embed code begins -->
  ${
    dynamicHeight?.value && embedScriptLink
      ? embedBaseScript(embedScriptLink)
      : ""
  }
  <iframe
    allowfullscreen${heightAttribute}
    width="${width}"
    frameborder="0"
    title="${iframeTitle}"
    src="${iframeSrc}"
  ></iframe>
  <!-- ${globalProps.appName} iframe embed code ends -->`;
};

export const htmlCodeGenerators = {
  inline: inlineEmbedCode,
  floatingPopup: floatingPopupEmbedCode,
  elementPopup: elementPopupEmbedCode,
  iframe: iframeEmbedCode,
};
